export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGIN_INFO = "LOGIN_INFO";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

export const NO_ACCESS = "NO_ACCESS";
export const RESET_NO_ACCESS = "RESET_NO_ACCESS";

// MFA (Authenticator TOTP)
export const MFA_REQUIRED = "MFA_REQUIRED";
export const MFA_SETUP_REQUIRED = "MFA_SETUP_REQUIRED";
export const VERIFY_MFA_REQUEST = "VERIFY_MFA_REQUEST";
export const VERIFY_MFA_SUCCESS = "VERIFY_MFA_SUCCESS";
export const VERIFY_MFA_FAILURE = "VERIFY_MFA_FAILURE";
export const RESET_MFA_STATE = "RESET_MFA_STATE";